<template>
  <div class="alarm-wrapper">
    <CommonHeader title="알림" :is-back-btn="true" :back-fn="close" :is-close-btn="false"></CommonHeader>
    <div class="content-body">
    <div class="alarm-wrap">
      <div class="alarm-setting">
        <ul v-if="isInit">
          <li>
            <span class="alarm-info">
                <span class="alarm-txt">시청 예약 알림</span>
            </span>
            <label class="switch-btn">
              <input type="checkbox" class="switch-input" name="live" @change="changeStatus('live')" v-model="liveChecked">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </li>
          <li>
            <span class="alarm-info">
                <span class="alarm-txt">관심 프로그램 업로드 알림</span>
            </span>
            <label class="switch-btn">
              <input type="checkbox" class="switch-input" name="upload" @change="changeStatus('upload')" v-model="uploadChecked">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import CommonHeader from '@/components/header/template/commonHeader'
export default {
  name: 'AlarmsSetup',
  components: { CommonHeader },
  props: {
    closeFn: {
      type: Function
    }
  },
  data () {
    return {
      isInit: false, // 데이터 초기화 완료 여부
      liveChecked: false, // 시청 예약 알림
      uploadChecked: false // 좋아요 프로그램 업로드 알림
    }
  },
  methods: {
    close () {
      this.closeFn()
    },
    changeStatus (type) {
      let live = this.liveChecked ? 'y' : 'n'
      let upload = this.uploadChecked ? 'y' : 'n'

      MyPooqService.setAlarmsReceiver({
        live: type === 'live' ? live : 'd',
        upload: type === 'upload' ? upload : 'd',
        movie: 'd',
        coupon: 'd',
        coin: 'd',
        event: 'd',
        myview: 'd',
        popular: 'd'
      })
    }
  },
  created () {
    window.scrollTo(0, 0)
    MyPooqService.getAlarmsReceiver().then(({ data }) => {
      this.liveChecked = data.live === 'y' // 시청 예약 알림
      this.uploadChecked = data.upload === 'y' // 좋아요 프로그램 업로드 알림
      this.isInit = true
    })
  }
}
</script>

<style scoped>
  .alarm-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: 4000;
  }
  .content-body {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }
  .content-body ::-webkit-scrollbar{
    display: none;
    background-color: transparent;
  }
  .alarm-wrap{
    background-color: #1b1b1b;
  }
  .alarm-setting ul {
    display: flex;
    flex-direction: column;
  }

  .alarm-setting li {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 15px;
    border-bottom: 1px solid #2f2f2f;
  }

  .alarm-setting .alarm-info {
    flex: 1;
    display: block;
  }

  .alarm-setting .alarm-txt {
    display: inline-block;
    vertical-align: middle;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 18px;
  }
  .alarm-onoff {
    width: 50px;
    background-color: #1abc9c
  }
  .alarm-icon-heart {
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  /* 토글형 체크박스 */
  .switch-btn{
    position: relative;
    display: inline-block;
    width: 44px;
    height: 27px;
    border-radius: 50px;
    cursor: pointer;
    vertical-align: middle;
  }

  .switch-input{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  .switch-label{
    position: relative;
    display: block;
    height: inherit;
    background: #eceeef;
    border-radius: inherit;
    -webkit-transition: 0.15s ease-out;
    -moz-transition: 0.15s ease-out;
    -o-transition: 0.15s ease-out;
    transition: 0.15s ease-out;

  }

  .switch-input:checked ~ .switch-label{
    background: #1351f9;
  }

  .switch-handle{
    position: absolute;
    top: 3px;
    left: 4px;
    width: 21px;
    height: 21px;
    background: white;
    border-radius: 50%;
    -webkit-transition: left 0.15s ease-out;
    -moz-transition: left 0.15s ease-out;
    -o-transition: left 0.15s ease-out;
    transition: left 0.15s ease-out;
  }

  .switch-input:checked ~ .switch-handle{
    left: 20px;
  }
</style>
